import lodash from 'lodash'
import React, { useEffect } from 'react'

import {
  Col,
  FormRow,
} from '../../../../../../../../1stlog-ui/src/components/Bootstrap'
import {
  FeedbackBadge,
  useField,
} from '../../../../../../../../1stlog-ui/src/components/Field'
import { units } from '../../../../../constants'

const validate = (v) => (v ? true : undefined)

const LimitedQuantity = (props) => {
  const {} = props

  const allowedAmount = useField('limitedQuantityDetails.amount')
  const limitedQuantityEnabled = useField('limitedQuantityEnabled')
  const amount = useField('amount')
  const unit = useField('unit')

  const {
    input: {
      value: isLimitedQuantityInvalid,
      onChange: setIsLimitedQuantityInvalid,
    },
    meta,
  } = useField('validation.isLimitedQuantityInvalid', {
    raw: true,
    validate,
    subscribeAll: true,
  })

  useEffect(() => {
    const formattedAmount = Number(String(amount || 0).replace(',', '.'))
    setIsLimitedQuantityInvalid(
      limitedQuantityEnabled && formattedAmount > allowedAmount,
    )
  }, [allowedAmount, limitedQuantityEnabled, amount])

  return isLimitedQuantityInvalid ? (
    <FormRow>
      <Col>
        <FeedbackBadge meta={meta}>
          {i18n.t('error_exceeds_quantity_new2', {
            defaultValue:
              'Pro Innenverpackung sind maximal {{allowedQuantity}} {{unit}} zugelassen',
            allowedQuantity: allowedAmount,
            unit: lodash.get(units, unit),
          })}
        </FeedbackBadge>
      </Col>
    </FormRow>
  ) : (
    <></>
  )
}

export default LimitedQuantity
